import { Popover } from '@ksyos/design-system';
import type { IPerson } from '../../../common/utils/getDisplayName';
import { getDisplayName } from '../../../common/utils/getDisplayName';

interface IDisplayShortWithTooltipProps {
    maxLength: number;
    practitioner?: IPerson;
    text?: string;
}

export function DisplayShortWithTooltip({ maxLength, text, practitioner }: IDisplayShortWithTooltipProps) {
    let tooltipText;
    let popoverContent;

    if (practitioner?.nameGiven) {
        tooltipText = `${practitioner.nameGiven.substring(0, maxLength)}...`;
        popoverContent = getDisplayName(practitioner, true);

        return <Popover content={popoverContent}>{tooltipText}</Popover>;
    }

    if (text) {
        if (text.length > maxLength) {
            tooltipText = text.substring(0, maxLength) + '...';
            popoverContent = text;

            return <Popover content={popoverContent}>{tooltipText}</Popover>;
        }

        return text;
    }
}
